import { useAutovioContext } from "../../hooks/useAutovioContext";
import { DunningList } from "../../lists/dunning/DunningList";

export function DrivingSchoolDunning() {
  const [{ drivingSchoolId }] = useAutovioContext();
  if (!drivingSchoolId) return null;
  return <DunningList filter={{ drivingSchoolId, showPostponed: true }} />;
}
